import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['form']

  initialize() {
    this.timeout = null
  }

  submit() {
    this.formTarget.requestSubmit()
  }

  debouncedSubmit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.formTarget.requestSubmit(), 250)
  }
}
